import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipInputComponent } from './tooltip-input.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule
    ],
    declarations: [
        TooltipInputComponent
    ],
    exports: [
        TooltipInputComponent
    ]
})

export class TooltipInputModule { }
